import Modal from 'components/shared/modal';
import { ButtonGroup, Button } from 'components/ui';
import React from 'react';

const MaximumAttemptsModal = ({
  isVisible,
  handleSave,
  handleDismissModal,
  statUrl,
}) => {
  return (
    <Modal
      show={isVisible}
      dismissCallback={handleDismissModal}
      title={t('lesson_overview.maximum_attempts.modal.title')}
    >
      <div>
        <div className="d-f fd-c mb-4">
          <p className="fw-b">
            {t('lesson_overview.maximum_attempts.modal.note')}
          </p>
          <p className="fw-600">
            {t('lesson_overview.maximum_attempts.modal.message')}
          </p>
          <p className="mb-16">
            {t('lesson_overview.maximum_attempts.modal.statistics.message')}{' '}
            <a
              href={statUrl}
              className="c-brand-blue"
              target="_blank"
              rel="noreferrer"
            >
              {t('lesson_overview.maximum_attempts.modal.statistics.title')}
            </a>
            .
          </p>
        </div>
      </div>
      <ButtonGroup alignEnd>
        <Button type="button" onClick={handleDismissModal}>
          {t('common.cancel')}
        </Button>
        <Button type="button" primary onClick={handleSave}>
          {t('common.save')}
        </Button>
      </ButtonGroup>
    </Modal>
  );
};

export default MaximumAttemptsModal;
